"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateStatusFieldValue = exports.getStatusFieldEmptyValue = void 0;
const getStatusFieldEmptyValue = () => {
    return { value: "", updated_on: null };
};
exports.getStatusFieldEmptyValue = getStatusFieldEmptyValue;
/**
 * Generate a StatusFieldValue
 * @param value
 */
const generateStatusFieldValue = (value) => {
    var _a, _b;
    return {
        value: (_a = value === null || value === void 0 ? void 0 : value.value) !== null && _a !== void 0 ? _a : "",
        updated_on: (_b = value === null || value === void 0 ? void 0 : value.updated_on) !== null && _b !== void 0 ? _b : null,
    };
};
exports.generateStatusFieldValue = generateStatusFieldValue;
